// src/services/storageService.js
/**
 * Salva i dati nel localStorage con gestione errori
 * @param {string} key - Chiave di storage
 * @param {any} value - Valore da salvare
 */
export const saveToStorage = (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Errore nel salvataggio in localStorage (${key}):`, error);
    }
  };
  
  /**
   * Recupera i dati dal localStorage con gestione errori
   * @param {string} key - Chiave di storage
   * @param {any} defaultValue - Valore di default se non trovato
   * @returns {any} Valore recuperato o valore di default
   */
  export const getFromStorage = (key, defaultValue = null) => {
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : defaultValue;
    } catch (error) {
      console.error(`Errore nel recupero da localStorage (${key}):`, error);
      return defaultValue;
    }
  };
  
 